import { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import "./MapaChilePage.css";

// ---------------------------------------------------------------------------
// Volcano data – 12 volcanoes matching Blender object names
// ---------------------------------------------------------------------------
const VOLCANES = {
  Parinacota: {
    nombre: "Volcán Parinacota",
    zona: "Putre · XV Región de Arica y Parinacota",
    tipo: "Poligenético",
    altura: "6.348 m s.n.m.",
    // estado: "",
    ultimaErupcion: "Sin registro histórico",
    img: "/Chile/VOLCAN1.webp",
    descripcion:
      "Volcán binacional ubicado en la frontera entre Chile y Bolivia, dentro del Parque Nacional Lauca.",
  }, 
  Lascar: {
    nombre: "Volcán Láscar",
    zona: "San Pedro de Atacama · XIV Región de Antofagasta",
    tipo: "Poligenético",
    altura: "5.592 m s.n.m.",
    // estado: "Potencialmente activo",
    ultimaErupcion: "1993, 2000, 2015",
    img: "/Chile/VOLCAN2.webp",
    descripcion:
      "Se encuentra en el altiplano chileno, cerca de la laguna Lejía y al norte del cerro Tumisa.",
  },
  Nevados_Ojos_Salado: {
    nombre: "Nevados Ojos del Salado",
    zona: "Copiapó · III Región de Atacama",
    tipo: "Poligenético",
    altura: "6.348 m s.n.m.",
    // estado: "Potencialmente activo",
    ultimaErupcion: "Sin registro histórico",
    img: "/Chile/VOLCAN3.webp",
    descripcion:
    "Ubicado en la frontera con Argentina, en el desierto de Atacama.",
  },
  Tupungatito: {
    nombre: "Volcán Tupungatito",
    zona: "San José de Maipo · Región Metropolitana",
    tipo: "Poligenético",
    altura: "5.603 m s.n.m.",
    // estado: "Activo",
    ultimaErupcion: "1959 - 1960, 1986",
    img: "/Chile/VOLCAN4.webp",
    descripcion:
     "Se encuentra en la cordillera de los Andes. Famoso por ser el volcan más activo cerca de  Santiago."
  },
  Laguna_del_Maule: {
    nombre: "Complejo Laguna del Maule",
    zona: "San Clemente · VII Región del Maule",
    tipo: "Monogenético / Poligenético",
    altura: "3.092 m s.n.m.",
    // estado: "Activo · vigilancia permanente",
    ultimaErupcion: "Hace ~2.000 años",
    img: "/Chile/VOLCAN5.webp",
    descripcion:
      "Es un sistema activo de alta peligrosidad situado en la region del Maule, Chile, cerca de la fontera argentina.",
  },
  Nevados_de_Chillan: {
    nombre: "Complejo Nevados de Chillán",
    zona: "Pinto y Coihueco · XVI Región de Ñuble",
    tipo: "Poligenético",
    altura: "3.216 m s.n.m.",
    // estado: "Erupción en curso",
    ultimaErupcion: "1861 - 1865, 1906, 1973, 2016 - Actualidad",
    img: "/Chile/VOLCAN6.webp",
    descripcion:
"Destaca por su alta actividad eruptiva, intensa actividad termal, y por ser un reconocido destino de turismo de montaña y esquí."  },

  Lonquimay: {
    nombre: "Volcán Lonquimay",
    zona: "Curacautín y Lonquimay · IX Región de La Araucanía",
    tipo: "Monogenético / Poligenético",
    altura: "2.865 m s.n.m.",
    // estado: "Erupción en curso",
    ultimaErupcion: "1853, 1887 - 1890, 1988 - 1990",
    img: "/Chile/VOLCAN7.webp",
    descripcion:
      'Famoso por su erupción navideña de 1988–1989, que creó el cono adventicio "Navidad". Rodeado de bosques de araucarias milenarias.',
  },
  Villarrica: {
    nombre: "Volcán Villarrica",
    zona: "Villarrica, Pucón y Panguipulli · IX Región de La Araucanía",
    tipo: "Poligenético",
    altura: "2.847 m s.n.m.",
    // estado: "Muy activo",
    ultimaErupcion: "1948 - 1949, 1963 - 1964, 1971, 1984, 2015",
    img: "/Chile/VOLCAN8.webp",
    descripcion:
    "Uno de los volcanes más activos de Chile. Presenta un lago de lava casi permanente en su cráter."
  },
  Calbuco: {
    nombre: "Volcán Calbuco",
    zona: "Puerto Varas y Puerto Montt · X Región de Los Lagos",
    tipo: "Poligenético",
    altura: "2.003 m s.n.m.",
    // estado: "Activo",
    ultimaErupcion: "1893, 1961, 2015",
    img: "/Chile/VOLCAN9.webp",	
    descripcion:
      "Su erupción sorpresiva de abril 2015 fue una de las más grandes de Chile en décadas. Generó una columna de ceniza de 15 km de altura en menos de cuatro horas, cubriendo de ceniza miles de km² en Chile y Argentina.",
  },
  Chaiten: {
    nombre: "Volcán Chaitén",
    zona: "Chaitén · X Región de Los Lagos",
    img: "/Chile/VOLCAN10.webp",
    tipo: "poligenético",
    altura: "950 m s.n.m.",
    // estado: "Activo",
    ultimaErupcion: "2008",
    descripcion:
      "La erupción de 2008 fue la primera en ~9.000 años. Destruyó parcialmente la ciudad de Chaitén y generó una de las mayores emisiones de riolita del siglo XX.",
  },
  Lautaro: {
    nombre: "Volcán Lautaro",
    zona: "Natales · XII Región de Magallanes y Antártica Chilena",
    tipo: "Poligenético",
    altura: "3.380 m s.n.m.",
    // estado: "Activo",
    ultimaErupcion: "1933, 1945, 1959",
    img: "/Chile/VOLCAN11.webp",
    descripcion:
      "Se ubica en el Campo de Hielo Patagónico Sur, accesible únicamente por expedición de alta montaña. Su actividad representa un riesgo potencial para los glaciares circundantes.",
  },
  Pali_Aike: {
    nombre: "Campo Volcánico Pali Aike",
    zona: "San Gregorio · XII Región de Magallanes y Antártica Chilena",
    tipo: "Monogenético",
    altura: "282 m s.n.m.",
    // estado: "Potencialmente activo",
    ultimaErupcion: "Sin registro histórico",
    img: "/Chile/VOLCAN12.webp",
    descripcion:
      "Es un campo volcánico estepario con paisajes lunares y rocosos, en la frontera con Argentina. El Parque Nacional Pali Aike protege este singular paisaje volcánico de la Patagonia.",
  },
};

// ---------------------------------------------------------------------------
// Pines en chile_map.glb: solo nodos cuya cabeza se nombra Pin_Head… son táctiles
// (p. ej. Pin_Head_Villarrica → clave "Villarrica" en VOLCANES).
// ---------------------------------------------------------------------------
const PIN_HEAD_PREFIX = "Pin_Head";

/**
 * Rutas bajo `public/` (CRA): deben ser absolutas desde el origen del sitio.
 * Si `img` es relativa (p. ej. "Chile/foo.webp"), se sirve mal en rutas anidadas del router.
 * @param {string | undefined} path
 */
function publicImageSrc(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}

/** @param {string} name */
function volcanoIdFromPinHeadName(name) {
  if (!name.startsWith(PIN_HEAD_PREFIX)) return null;
  const id = name.startsWith(`${PIN_HEAD_PREFIX}_`)
    ? name.slice(PIN_HEAD_PREFIX.length + 1)
    : name.slice(PIN_HEAD_PREFIX.length);
  return id || null;
}

/** Mesh u Object3D raíz del pin (nombre Pin_Head*) para intersectObjects(…, recursive). */
function collectPinHeadPickTargets(model) {
  const targets = [];
  model.traverse((obj) => {
    if (obj.name.startsWith(PIN_HEAD_PREFIX)) targets.push(obj);
  });
  return targets;
}

/** Desde el objeto impactado, sube hasta un antepasado Pin_Head* y resuelve la ficha. */
function volcanFromHitObject(hitObject) {
  for (let o = hitObject; o; o = o.parent) {
    const id = volcanoIdFromPinHeadName(o.name);
    if (id && VOLCANES[id]) return VOLCANES[id];
  }
  return null;
}

/** Jitter en píxeles de pantalla: pin pequeño + dedo grueso suelen fallar con un solo rayo. */
const PICK_SCREEN_JITTER_PX = [
  [0, 0],
  [-18, 0],
  [18, 0],
  [0, -18],
  [0, 18],
  [-13, -13],
  [13, -13],
  [-13, 13],
  [13, 13],
  [-32, 0],
  [32, 0],
  [0, -32],
  [0, 32],
];

/**
 * Varios raycasts alrededor del punto de pantalla; primer Pin_Head válido gana.
 * @param {THREE.Camera} camera
 * @param {THREE.Raycaster} raycaster
 * @param {THREE.Object3D[]} pinRoots
 */
function pickVolcanFromClientXY(clientX, clientY, domElement, camera, raycaster, pinRoots) {
  const rect = domElement.getBoundingClientRect();
  if (rect.width < 2 || rect.height < 2 || pinRoots.length === 0) return null;
  raycaster.near = 0.02;
  raycaster.far = 500;
  for (const [jx, jy] of PICK_SCREEN_JITTER_PX) {
    const sx = clientX + jx;
    const sy = clientY + jy;
    if (sx < rect.left - 2 || sx > rect.right + 2 || sy < rect.top - 2 || sy > rect.bottom + 2) {
      continue;
    }
    const nx = ((sx - rect.left) / rect.width) * 2 - 1;
    const ny = -((sy - rect.top) / rect.height) * 2 + 1;
    raycaster.setFromCamera(new THREE.Vector2(nx, ny), camera);
    const hits = raycaster.intersectObjects(pinRoots, true);
    if (hits.length === 0) continue;
    const volcan = volcanFromHitObject(hits[0].object);
    if (volcan) return volcan;
  }
  return null;
}

// ---------------------------------------------------------------------------
// Modal de volcán
// ---------------------------------------------------------------------------
function VolcanModal({ volcan, onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <div
      className="volcan-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={volcan.nombre}
    >
      <div className="volcan-modal" onClick={(e) => e.stopPropagation()}>
        {/* Pill handle */}
        <div className="volcan-modal-handle" aria-hidden />

        {/* Imagen opcional: marco cuadrado responsive, webp completo (contain) */}
        <div className="volcan-modal-img" aria-hidden>
          <div className="volcan-modal-img-frame">
            {volcan.img ? (
              <img
                className="volcan-modal-foto"
                src={publicImageSrc(volcan.img)}
                alt={volcan.nombre}
              />
            ) : (
              <span className="volcan-modal-emoji" aria-hidden>
                🌋
              </span>
            )}
          </div>
          <h2 className="volcan-modal-title">{volcan.nombre}</h2>
        </div>

        {/* Contenido */}
        <div className="volcan-modal-body">
       
          <p className="volcan-modal-zona">{volcan.zona}</p>


          <div className="volcan-modal-tags">
            <span className="volcan-tag">{volcan.tipo}</span>
            {/* <span className="volcan-tag volcan-tag-estado">{volcan.estado}</span> */}
          </div>

          <p className="volcan-modal-desc">{volcan.descripcion}</p>

          <dl className="volcan-modal-data">
            <div className="volcan-data-item">
              <dt>Altura</dt>
              <dd>{volcan.altura}</dd>
            </div>
            <div className="volcan-data-item">
              <dt>Erupciones relevantes</dt>
              <dd>{volcan.ultimaErupcion}</dd>
            </div>
          </dl>
        </div>

        <button
          type="button"
          className="volcan-modal-close"
          onClick={onClose}
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

/** Máx. desplazamiento press→release aún considerado “tap” sobre un pin (móvil). */
const PIN_TAP_MAX_MOVE_PX = 72;
/** Evita doble apertura cuando el navegador dispara pointer + touch en el mismo gesto. */
const PIN_PICK_DEBOUNCE_MS = 380;

// ---------------------------------------------------------------------------
// Componente principal
// ---------------------------------------------------------------------------
export default function MapaChilePage() {
  const mountRef = useRef(null);
  const [activeVolcan, setActiveVolcan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  // Three.js refs — never trigger re-renders
  const sceneRef      = useRef(null);
  const rendererRef   = useRef(null);
  const cameraRef     = useRef(null);
  const controlsRef   = useRef(null);
  const frameRef      = useRef(null);
  const pinMeshesRef  = useRef([]);
  const raycasterRef  = useRef(new THREE.Raycaster());
  const pinTapCleanupRef = useRef(null);
  const setActiveVolcanRef = useRef(setActiveVolcan);
  setActiveVolcanRef.current = setActiveVolcan;
  // Límites de pan: se calculan al cargar el modelo
  const panLimitsRef  = useRef(null);

  // ------------------------------------------------------------------
  // Inicializar escena Three.js
  // ------------------------------------------------------------------
  const initScene = useCallback(() => {
    const mount = mountRef.current;
    if (!mount || rendererRef.current) return;

    // Tras salir de RA a veces el flex aún no tiene caja (clientWidth/Height = 0);
    // sin renderer la página queda en “Cargando…” y sin interacción.
    const fallbackW = Math.min(
      typeof window !== "undefined" ? window.innerWidth : 430,
      430
    );
    const fallbackH =
      typeof window !== "undefined"
        ? Math.max(window.innerHeight - 96, 240)
        : 560;
    const w = mount.clientWidth || fallbackW;
    const h = mount.clientHeight || fallbackH;

    // Scene
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x120808);
    sceneRef.current = scene;

    // Camera
    const camera = new THREE.PerspectiveCamera(40, w / h, 0.01, 200);
    camera.position.set(0, 5, 6);
    cameraRef.current = camera;

    // Renderer
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(w, h);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    mount.appendChild(renderer.domElement);
    rendererRef.current = renderer;

    // Pines: listeners en el <canvas> (no en el div React). OrbitControls hace setPointerCapture
    // en el canvas, y en móvil los eventos no llegan bien al padre → el raycast no corría.
    pinTapCleanupRef.current?.();
    const dom = renderer.domElement;
    let lastPinPickAt = 0;
    const tap = {
      x: 0,
      y: 0,
      downX: 0,
      downY: 0,
      pointerId: -1,
      touchId: /** @type {number | null} */ (null),
    };

    const openPinIfHitAt = (upX, upY, downX, downY) => {
      const cam = cameraRef.current;
      const pins = pinMeshesRef.current;
      const rc = raycasterRef.current;
      if (!cam || pins.length === 0) return;
      const now = Date.now();
      if (now - lastPinPickAt < PIN_PICK_DEBOUNCE_MS) return;
      let volcan =
        pickVolcanFromClientXY(upX, upY, dom, cam, rc, pins) ||
        pickVolcanFromClientXY(downX, downY, dom, cam, rc, pins) ||
        pickVolcanFromClientXY(
          (upX + downX) * 0.5,
          (upY + downY) * 0.5,
          dom,
          cam,
          rc,
          pins
        );
      if (!volcan) return;
      lastPinPickAt = Date.now();
      setActiveVolcanRef.current(volcan);
    };

    const onPointerDownCap = (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      tap.x = e.clientX;
      tap.y = e.clientY;
      tap.downX = e.clientX;
      tap.downY = e.clientY;
      tap.pointerId = e.pointerId;
    };
    const onPointerUpCap = (e) => {
      if (tap.pointerId === -1) return;
      if (e.pointerId !== tap.pointerId) return;
      tap.pointerId = -1;
      const dx = e.clientX - tap.downX;
      const dy = e.clientY - tap.downY;
      if (Math.hypot(dx, dy) > PIN_TAP_MAX_MOVE_PX) return;
      const upX = e.clientX;
      const upY = e.clientY;
      const dX = tap.downX;
      const dY = tap.downY;
      requestAnimationFrame(() => {
        openPinIfHitAt(upX, upY, dX, dY);
      });
    };
    const onPointerCancelCap = () => {
      tap.pointerId = -1;
      tap.touchId = null;
    };

    const onTouchStartCap = (e) => {
      if (e.touches.length !== 1) return;
      const t = e.touches[0];
      tap.x = t.clientX;
      tap.y = t.clientY;
      tap.downX = t.clientX;
      tap.downY = t.clientY;
      tap.touchId = t.identifier;
    };
    const onTouchEndCap = (e) => {
      if (tap.touchId == null) return;
      const t = [...e.changedTouches].find((c) => c.identifier === tap.touchId);
      tap.touchId = null;
      if (!t) return;
      const dx = t.clientX - tap.downX;
      const dy = t.clientY - tap.downY;
      if (Math.hypot(dx, dy) > PIN_TAP_MAX_MOVE_PX) return;
      const upX = t.clientX;
      const upY = t.clientY;
      const dX = tap.downX;
      const dY = tap.downY;
      requestAnimationFrame(() => {
        openPinIfHitAt(upX, upY, dX, dY);
      });
    };

    /** Click nativo: respaldo cuando pointer/touch no entregan pares coherentes (p. ej. algunos Android). */
    const onCanvasClick = (e) => {
      if (e.target !== dom) return;
      if (typeof e.button === "number" && e.button !== 0) return;
      requestAnimationFrame(() => {
        openPinIfHitAt(e.clientX, e.clientY, e.clientX, e.clientY);
      });
    };

    dom.addEventListener("pointerdown", onPointerDownCap, true);
    dom.addEventListener("pointerup", onPointerUpCap, true);
    dom.addEventListener("pointercancel", onPointerCancelCap, true);
    dom.addEventListener("touchstart", onTouchStartCap, { capture: true, passive: true });
    dom.addEventListener("touchend", onTouchEndCap, { capture: true, passive: true });
    dom.addEventListener("click", onCanvasClick);

    pinTapCleanupRef.current = () => {
      dom.removeEventListener("pointerdown", onPointerDownCap, true);
      dom.removeEventListener("pointerup", onPointerUpCap, true);
      dom.removeEventListener("pointercancel", onPointerCancelCap, true);
      dom.removeEventListener("touchstart", onTouchStartCap, true);
      dom.removeEventListener("touchend", onTouchEndCap, true);
      dom.removeEventListener("click", onCanvasClick);
      pinTapCleanupRef.current = null;
    };

    // Luces: cálidas para resaltar el naranja del mapa
    scene.add(new THREE.AmbientLight(0xffe5cc, 1.4));
    const key = new THREE.DirectionalLight(0xffd090, 2.2);
    key.position.set(4, 10, 5);
    scene.add(key);
    const fill = new THREE.DirectionalLight(0x88aaff, 0.5);
    fill.position.set(-5, 3, -3);
    scene.add(fill);

    // OrbitControls — esquema tipo mapa: pan con 1 dedo/clic izq, rotar con 2 dedos/clic der
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping      = true;
    controls.dampingFactor      = 0.06;
    controls.autoRotate         = false;
    controls.screenSpacePanning = true;   // pan paralelo a la pantalla (más natural)
    controls.enablePan          = true;
    controls.panSpeed           = 1.2;
    controls.minPolarAngle      = Math.PI / 12;  // puede mirar casi desde arriba
    controls.maxPolarAngle      = Math.PI / 1.9; // puede ver levemente por debajo
    controls.minDistance        = 1;
    controls.maxDistance        = 22;

    // Ratón: clic izq = mover (pan), clic der = rotar
    controls.mouseButtons = {
      LEFT:   THREE.MOUSE.PAN,
      MIDDLE: THREE.MOUSE.DOLLY,
      RIGHT:  THREE.MOUSE.ROTATE,
    };

    // Táctil: 1 dedo = mover el mapa, 2 dedos = zoom + rotar
    controls.touches = {
      ONE: THREE.TOUCH.PAN,
      TWO: THREE.TOUCH.DOLLY_ROTATE,
    };

    controlsRef.current = controls;

    // Cargar el GLB
    const loader = new GLTFLoader();
    loader.load(
      `${process.env.PUBLIC_URL || ""}/models/chile_map.glb`,
      (gltf) => {
        const model = gltf.scene;

        // Centrar el modelo
        const box    = new THREE.Box3().setFromObject(model);
        const center = box.getCenter(new THREE.Vector3());
        model.position.sub(center);
        scene.add(model);

        // Bounding box en espacio mundo después de centrar
        const worldBox  = new THREE.Box3().setFromObject(model);
        const size      = worldBox.getSize(new THREE.Vector3());

        // Límites de pan: el target nunca puede salir del modelo.
        // Se usa 80 % del semiancho/semilargo para que siempre quede
        // algo del mapa en pantalla, y se permite moverse libremente en Y
        // (altura de la cámara respecto al modelo).
        const marginX = size.x * 0.5;   // el mapa es estrecho: margen amplio
        const marginZ = size.z * 0.45;  // norte-sur: permite llegar a los extremos
        panLimitsRef.current = {
          minX: worldBox.min.x - marginX,
          maxX: worldBox.max.x + marginX,
          minY: worldBox.min.y - size.y,
          maxY: worldBox.max.y + size.y * 3,
          minZ: worldBox.min.z + size.z * 0.05, // deja ver un poco más allá del extremo
          maxZ: worldBox.max.z - size.z * 0.05,
        };

        // Solo cabezas de pin (nombre Pin_Head*): cono/cuerpo del pin no abren modal
        pinMeshesRef.current = collectPinHeadPickTargets(model);

        // Ajustar cámara a la escala real del modelo
        const maxDim = Math.max(size.x, size.y, size.z);
        const dist   = maxDim * 1.1;
        camera.position.set(0, dist * 0.7, dist * 0.85);
        camera.lookAt(0, 0, 0);
        controls.target.set(0, 0, 0);
        controls.update();

        setLoading(false);
      },
      undefined,
      (err) => {
        console.error("Error cargando GLB:", err);
        setLoadError("No se pudo cargar el mapa 3D.");
        setLoading(false);
      }
    );

    // Loop de animación
    const animate = () => {
      frameRef.current = requestAnimationFrame(animate);
      controls.update();

      // Limitar el target del pan para que el modelo nunca salga de pantalla.
      // Se aplica DESPUÉS de update() y ANTES de render() para que la cámara
      // se renderice ya con el target corregido, sin parpadeos.
      const limits = panLimitsRef.current;
      if (limits) {
        const t = controls.target;
        t.x = Math.max(limits.minX, Math.min(limits.maxX, t.x));
        t.y = Math.max(limits.minY, Math.min(limits.maxY, t.y));
        t.z = Math.max(limits.minZ, Math.min(limits.maxZ, t.z));
      }

      renderer.render(scene, camera);
    };
    animate();
  }, []);

  // ------------------------------------------------------------------
  // Cleanup
  // ------------------------------------------------------------------
  const disposeScene = useCallback(() => {
    pinTapCleanupRef.current?.();
    pinTapCleanupRef.current = null;
    if (frameRef.current) cancelAnimationFrame(frameRef.current);
    frameRef.current = null;
    const renderer = rendererRef.current;
    const mount    = mountRef.current;
    if (renderer && mount && renderer.domElement.parentNode === mount) {
      mount.removeChild(renderer.domElement);
    }
    renderer?.dispose();
    rendererRef.current  = null;
    sceneRef.current     = null;
    cameraRef.current    = null;
    controlsRef.current  = null;
    pinMeshesRef.current = [];
    panLimitsRef.current = null;
  }, []);

  // ------------------------------------------------------------------
  // Montaje / desmontaje
  // ------------------------------------------------------------------
  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    const syncCanvasToMount = () => {
      const m = mountRef.current;
      const camera = cameraRef.current;
      const renderer = rendererRef.current;
      if (!m || !camera || !renderer) return;
      const cw = m.clientWidth;
      const ch = m.clientHeight;
      if (cw < 2 || ch < 2) return;
      camera.aspect = cw / ch;
      camera.updateProjectionMatrix();
      renderer.setSize(cw, ch);
    };

    const id = requestAnimationFrame(() => {
      initScene();
      syncCanvasToMount();
    });

    const ro = new ResizeObserver(() => syncCanvasToMount());
    ro.observe(mount);

    const onWinResize = () => syncCanvasToMount();
    window.addEventListener("resize", onWinResize);

    return () => {
      cancelAnimationFrame(id);
      ro.disconnect();
      window.removeEventListener("resize", onWinResize);
      disposeScene();
    };
  }, [initScene, disposeScene]);

  // ------------------------------------------------------------------
  // Render
  // ------------------------------------------------------------------
  return (
    <div className="mapa-chile">
      {/* Header */}
      <header className="mapa-chile-header">
        <Link to="/" className="mapa-chile-back">← Inicio</Link>
        <h1>Mapa de Volcanes</h1>
        <Link to="/ar" className="mapa-chile-back mapa-chile-back-right">
          Cámara RA
        </Link>
      </header>

      {/* Canvas Three.js — application + describedby para lectores de pantalla */}
      <div
        className="mapa-chile-canvas"
        ref={mountRef}
        role="application"
        tabIndex={0}
        aria-label="Mapa tridimensional de volcanes de Chile"
        {...(!loading && !loadError
          ? { "aria-describedby": "mapa-chile-hint-text" }
          : {})}
      />

      {/* Ayuda gestos: visible y anunciada cuando el mapa está listo */}
      {!loading && !loadError && (
        <p id="mapa-chile-hint-text" className="mapa-chile-hint">
          <span className="mapa-chile-hint-inner">
            Un dedo: mover el mapa · Dos dedos: rotar y zoom · Toca un pin en el mapa{" "}
            <span className="mapa-chile-hint-icon" aria-hidden="true">
              📍
            </span>
          </span>
        </p>
      )}

      {/* Loading */}
      {loading && !loadError && (
        <div className="mapa-chile-loading">
          <div className="mapa-chile-spinner" aria-hidden />
          <p>Cargando mapa de Chile…</p>
        </div>
      )}

      {/* Error */}
      {loadError && (
        <div className="mapa-chile-error">
          <span aria-hidden>⚠️</span>
          <p>{loadError}</p>
        </div>
      )}

      {/* Modal volcán */}
      {activeVolcan && (
        <VolcanModal
          volcan={activeVolcan}
          onClose={() => setActiveVolcan(null)}
        />
      )}
    </div>
  );
}
